
import { Component, Prop, Vue } from "vue-property-decorator";
import { DimssaButton, ButtonState } from "@/components/shared/dimssa-button.vue";
import * as Model from "@gigalot/data-models";
import lodash from "lodash";
import moment from "moment";
import Decimal from "decimal.js";

@Component({
  components: {
    DimssaButton,
  },
})
export default class Cribs extends Vue {
  @Prop() selectedKraal!: string;
  call: Decimal = new Decimal(-1);
  score = "";
  loading = false;
  swipeDirection = "None";
  edited = false;
  cribScores: Model.CribReadingItem[] = [];
  cribHistory: any = [];
  currentCribHistory: any = [];
  page = 1;
  search = "";
  filter = {};
  sequence = 0;
  callIncrement: number = 1.0;
  rations: any[] = [];
  useCribAliases = true;
  useAutoCribAdjustments = true;
  cribReadingAdjustments: any = {};
  newNote: string = "";

  keys = ["Kraal", "Ration", "Score", "Call", "Drive Order"];
  itemsPerPage = 1;
  cribHistoryHeader = [
    { text: "Date", value: "readingDate", align: "center" },
    { text: "Animals", value: "animalCount", align: "center" },
    { text: "Ration", value: "ration", align: "center" },
    { text: "Score", value: "score", align: "center" },
    { text: "Call", value: "call", align: "center" },
    { text: "Fed", value: "actualFed", align: "center" },
  ];

  getColor(status: string) {
    switch (status) {
      case "waiting":
        return "orange";
      case "skipped":
        return "red";
      case "blocked":
        return "grey";
      case "done":
        return "green";
    }
  }

  getGenderColor(gender: string) {
    if (gender === "Male") {
      return "light-blue";
    } else if (gender === "Female") return "pink";
    else return "grey";
  }

  getButtonState(score: number) {
    if (this.score === score.toString()) return "success";
    else return "ready";
  }
  mounted() {
    //TODO: Get dat from store instaed of calls (Should be in store from the cribSummary screen)
    //load kraal if kraal selected
    this.$store.dispatch("user/addFirebaseCallback", this.getCribPlansDb);

    //this.useCribAliases = JSON.parse(json.data.Configuration).useCribAliases;
    //this.useAutoCribAdjustments = JSON.parse(json.data.Configuration).useCribAutoAdjustments;
  }

  formatDecimal(number: string) {
    return parseFloat(number).toFixed(2);
  }

  decrement(seq: number, previousCall: string) {
    if (!this.cribReadingAdjustments[0].callMoisture) {
      let dmf = this.getDryMatterFactor(this.rationGuid);
      let c = new Decimal(this.callIncrement);
      let d = parseFloat(c.div(dmf).toFixed(6));
      this.call = new Decimal(parseFloat(previousCall) - d);
    } else {
      this.call = new Decimal(parseFloat(previousCall) - this.callIncrement);
    }

    this.cribScores[this.getIndex(seq)].call = parseFloat(this.call.toFixed(6));
    this.edited = true;
  }

  increment(seq: number, previousCall: string) {
    if (!this.cribReadingAdjustments[0].callMoisture) {
      let dmf = this.getDryMatterFactor(this.rationGuid);
      let c = new Decimal(this.callIncrement);
      let d = parseFloat(c.div(dmf).toFixed(6));
      this.call = new Decimal(parseFloat(previousCall) + d);
    } else {
      this.call = new Decimal(parseFloat(previousCall) + this.callIncrement);
    }

    this.cribScores[this.getIndex(seq)].call = parseFloat(this.call.toFixed(6));
    this.edited = true;
  }

  getScore(item: Model.CribReadingItem) {
    if (item.score === -1) {
      return item.status;
    } else return item.score;
  }

  getAlias(scored: number) {
    if (this.cribReadingAdjustments[0].useAliases) {
      if (this.cribReadingAdjustments.length > 0) {
        let alias: any = lodash.find(this.cribReadingAdjustments[0].cribReadingAdjustment, (yes) => {
          if (yes.score == scored) return yes;
        });
        if (!alias) {
          return "-";
        }
        return alias?.userAlias;
      }
    } else return scored;
  }

  adjustedScore(score: number): number {
    let adjustment = lodash.find(this.cribReadingAdjustments[0].cribReadingAdjustment, { score: score });
    // return 2;
    return adjustment?.autoCallAdjustment ?? 0;
  }

  doAutoAdjustment(score: number, previousCall: string, item: any) {
    if ((item.score === -1) && (!this.cribReadingAdjustments[0].callMoisture))
    {     
       let dmf = this.getDryMatterFactor(this.rationGuid);
      let c = new Decimal(previousCall);
      previousCall = c.div(dmf).toFixed(2);
    }

    this.select(score, item.sequence);
    item.score = score;
    if (this.useAutoCribAdjustments) {
      if (!this.cribReadingAdjustments[0].callMoisture) {
        let dmf = this.getDryMatterFactor(this.rationGuid);
        let c = new Decimal(this.adjustedScore(score));
        let d = parseFloat(c.div(dmf).toFixed(6));
        let newCall = new Decimal(parseFloat(previousCall) + d);
        item.call = parseFloat(newCall.toFixed(6));
      } else {
        let newCall = parseFloat(previousCall) + this.adjustedScore(score);
        item.call = parseFloat(newCall.toFixed(6));
      }
    }
  }

  doCalculatedAdjustment(score: number, cribReading: any) {
        //subtract leftover from yesterdays fed amount
    this.select(score, cribReading.sequence);
    if (score < 0) score = 0;
    cribReading.score = score;

    if (cribReading.animalCount) {
      let previousActualFed = this.currentCribHistory[this.currentCribHistory.length - 1].actualFed;
      let yesterdayCribScore = this.currentCribHistory[this.currentCribHistory.length - 1].score;
      if (yesterdayCribScore < 0) yesterdayCribScore = 0; //for safety (if not scored to not go negative)
      let totalFeedInCrib = (previousActualFed * cribReading.animalCount) + yesterdayCribScore;
      if (totalFeedInCrib < 0) totalFeedInCrib = 0; //for safety (cant have negative feed in crib)
      let feedConsumed = totalFeedInCrib - (score??0);
      let challengeAmount = this.getChallengePercentage(this.rationGuid);
      let challenge = (1 + challengeAmount / 100) * feedConsumed;
      let allocatedFeed = (challenge - score) / cribReading.animalCount;

      if (allocatedFeed < 0) allocatedFeed = 0;
      if (!this.cribReadingAdjustments[0].callMoisture) {
        let dmf = this.getDryMatterFactor(this.rationGuid);
        let c = new Decimal(parseFloat(allocatedFeed.toFixed(6)));
        let d = parseFloat(c.div(dmf).toFixed(6));
        cribReading.call = parseFloat(d.toFixed(6));
      } else {
        cribReading.call = parseFloat(allocatedFeed.toFixed(6));
      }
    }
  }

  dOldCalculatedAdjustment(leftover: number, previousCall: string, item: any) {
    //subtract leftover from yesterdays fed amount
    this.select(leftover, item.sequence);
    item.score = leftover;

    let yesterdaysAmount = 0;
    if (item.animalCount) {
      yesterdaysAmount = parseFloat(previousCall) - leftover / item.animalCount;
    } else {
      yesterdaysAmount = parseFloat(previousCall);
    }
    //add challenge amount
    let challengeAmount = this.getChallengePercentage(this.rationGuid);

    let newAmount = yesterdaysAmount;

    if (leftover > 5) {
      newAmount = (1 + challengeAmount / 100) * yesterdaysAmount;
    }
    if (item.animalCount) {
      newAmount = newAmount - leftover / item.animalCount;
    } else {
      newAmount = newAmount;
    }
    if (newAmount < 0) newAmount = 0;

    if (!this.cribReadingAdjustments[0].callMoisture) {
      let dmf = this.getDryMatterFactor(this.rationGuid);
      let c = new Decimal(parseFloat(newAmount.toFixed(6)));
      let d = parseFloat(c.div(dmf).toFixed(6));
      item.call = parseFloat(d.toFixed(6));
    } else {
      item.call = parseFloat(newAmount.toFixed(6));
    }
  }

  gotoKraal(event: any) {
    this.$router.push(`/cribscores?selectedKraal=${event.kraalId}`);
    this.$router.go(0);
  }

  getDryMatterFactor(rationGuid: string) {
    for (let i = 0; i < this.rations.length; i++) {
      if (this.rations[i].guid === rationGuid) {
        return this.rations[i].dryMatterFactor?.dryMatterFactor ? this.rations[i].dryMatterFactor.dryMatterFactor : 1.0;
      }
    }
    return 1.0;
  }

  getChallengePercentage(rationGuid: string) {
    for (let i = 0; i < this.rations.length; i++) {
      if (this.rations[i].guid === rationGuid) {
        return this.rations[i].challengePercentage ? this.rations[i].challengePercentage : 0;
      }
    }
    return 0;
  }

  getCallPerHead(rationGuid: string, wet: boolean) {
    wet = this.cribReadingAdjustments[0].callMoisture === wet;

    if (this.cribReadingAdjustments[0].callMoisture) {
      if (wet) {
        let a = new Decimal(this.boundcall);
        return a.toFixed(3);
      } else {
        let a = new Decimal(this.boundcall);
        let dmf = this.getDryMatterFactor(rationGuid);
        let d = a.mul(dmf);
        return d.toFixed(3);
      }
    } else {
      if (wet) {
        let a = new Decimal(this.boundcall);
        return a.toFixed(3);
      } else {
        let a = new Decimal(this.boundcall);
        let dmf = this.getDryMatterFactor(rationGuid);
        let d = a.div(dmf);
        return d.toFixed(3);
      }
    }
  }

  getTotalCall(rationGuid: string, wet: boolean) {
    if (this.boundAnimals) {
      wet = this.cribReadingAdjustments[0].callMoisture === wet;

      if (this.cribReadingAdjustments[0].callMoisture) {
        if (wet) {
          let a = new Decimal(this.boundcall);
          let b = new Decimal(this.boundAnimals);
          let c = a.mul(b);
          return c.toFixed(0);
        } else {
          let a = new Decimal(this.boundcall);
          let b = new Decimal(this.boundAnimals);
          let c = a.mul(b);
          let dmf = this.getDryMatterFactor(rationGuid);
          let d = c.mul(dmf);
          return d.toFixed(0);
        }
      } else {
        if (wet) {
          let a = new Decimal(this.boundcall);
          let b = new Decimal(this.boundAnimals);
          let c = a.mul(b);
          return c.toFixed(0);
        } else {
          let a = new Decimal(this.boundcall);
          let b = new Decimal(this.boundAnimals);
          let c = a.mul(b);
          let dmf = this.getDryMatterFactor(rationGuid);
          let d = c.div(dmf);
          return d.toFixed(0);
        }
      }
    }
  }

  get boundscore() {
    let index = this.getIndex(this.sequence);
    if (this.cribScores[index].score === -1) return "#";
    else return this.cribScores[index].score;
  }

  get boundcall() {
    //(wet)

    let index = this.getIndex(this.sequence);
    if (this.cribScores[index].score === -1) {
      if (this.currentCribHistory.length > 0) {
        if (this.cribReadingAdjustments[0].callonPreviousCall) {
          this.cribScores[index].call = this.currentCribHistory[this.currentCribHistory.length - 1].call.toFixed(3);
          return this.currentCribHistory[this.currentCribHistory.length - 1].call.toFixed(3);
        } else {
          this.cribScores[index].call = this.currentCribHistory[this.currentCribHistory.length - 1].actualFed.toFixed(3);
          return this.currentCribHistory[this.currentCribHistory.length - 1].actualFed.toFixed(3);
        }
      } else {
        if (!this.cribReadingAdjustments[0].callMoisture) {
          let dmf = this.getDryMatterFactor(this.rationGuid);
          let c = new Decimal(this.cribScores[index].call ?? 0);
          let d = c.mul(dmf);
          return d;
        } else return this.cribScores[index].call;
      }
    } else {
      if (!this.cribReadingAdjustments[0].callMoisture) {
        let dmf = this.getDryMatterFactor(this.rationGuid);
        let c = new Decimal(this.cribScores[index].call ?? 0);
        let d = c.mul(dmf);
        return d;
      } else return this.cribScores[index].call;
    }
  }

  get rationGuid() {
    let index = this.getIndex(this.sequence);
    return this.cribScores[index].rationGuid;
  }

  get boundAnimals() {
    let index = this.getIndex(this.sequence);
    return this.cribScores[index].animalCount ? this.cribScores[index].animalCount : 0;
  }

  set boundcall(value: any) {
    let index = this.getIndex(this.sequence);
    this.call = value;
    this.cribScores[index].call = value;
    this.edited = true;
  }

  async getCribPlansDb() {
    this.loading = true;
    try {
      console.log("getCribPlansDb()");
      this.cribScores = await this.$store.dispatch("data/getTodaysCribScores");
      this.cribReadingAdjustments = await this.$store.dispatch("data/getCribReadingAdjustments");
      this.rations = await this.$store.dispatch("data/getRationDMFs");
      this.callIncrement = parseFloat(await this.$store.dispatch("data/getCallIncrement"));
      this.cribScores = lodash.sortBy(this.cribScores, function (o) {
        return o.kraalId;
      });
      console.log("Done Downloading");
      this.cribHistory = await this.$store.dispatch("data/getCribScoreHistory");
    } catch (err) {
      console.log("getCribPlans -> error: " + err);
    } finally {
      if (this.selectedKraal) {
        console.log(this.selectedKraal);
        let index = 0;
        let sequence = this.getSequence(this.selectedKraal);
        if (sequence > -1) {
          this.page = sequence + 1;
          this.sequence = sequence;
          let index2 = this.getIndex(sequence);
          this.currentCribHistory = this.getcribHistory(this.cribScores[index2].kraalId);
        }

        if (this.currentCribHistory.length > 0) {
          this.call = new Decimal(this.currentCribHistory[this.currentCribHistory.length - 1].call);
        }
        console.log(`setting page index to ${this.page}`);
      } else console.log("nothing in selected Kraal");

      this.loading = false;
      //default data
    }
  }

  getIndex(sequence: number) {
    let index = lodash.findIndex(this.cribScores, { sequence: sequence });
    return index;
  }
  getpageIndex(kraalId: string) {
    let index = lodash.findIndex(this.cribScores, { kraalId: kraalId }) + 1;

    return index;
  }
  getSequence(kraalId: string) {
    let seq = -1;
    let item = lodash.find(this.cribScores, { kraalId: kraalId });
    if (item) {
      if (item.sequence != undefined) {
        return item.sequence;
      }
    } else return seq;
    return seq;
  }

  getcribHistory(kraalId: string) {
    let history: any[] = [];
    for (let day of this.cribHistory) {
      try {
        let hs = lodash.clone(lodash.find(day.cribScores, { kraalId: kraalId }));
        if (hs) {
          if (!this.cribReadingAdjustments[0].callMoisture) {
            let dmf = this.getDryMatterFactor(this.rationGuid);
            let c = new Decimal(hs.call);
            let d = new Decimal(hs.actualFed);
            hs.call = new Decimal(c.mul(dmf).toFixed(3));
            hs.actualFed = d.mul(dmf);
          }
          history.push(hs);
        }
      } catch (err) {
        console.warn(`Kraal ${kraalId} had no feed amount for day`);
      }
    }
    return history;
  }
  get themeClass(): string {
    return this.$store.state.lightDarkMode;
  }

  async updateServer(editedItem?: any) {
    console.log(editedItem);
    if (editedItem) {
      editedItem.actualFed = 0; //??
      editedItem.call = parseFloat(this.getCallPerHead(editedItem.rationGuid, true));
      try {
        console.log("updateServer()");
        let json = await this.$store.dispatch("cribScores/save", editedItem);
      } catch (err) {
        console.log(err);
        throw err;
      }
    }
  }
  saveNote(cribscore: Model.CribReadingItem) {
    let note = new Model.NoteItem();
    note.text = this.newNote;
    note.timestamp = Date.now();
    if (!cribscore.notes) {
      cribscore.notes = [];
    }
    cribscore.notes?.push(note);
    this.updateServer(cribscore);
  }
  get moment() {
    return this.$store.state.moment;
  }

  get numberOfPages() {
    return Math.ceil(this.cribScores.length / this.itemsPerPage);
  }

  nextPage() {
    let index = this.getIndex(this.sequence);
    //save crib score before going to next page (if something changed)
    if (this.edited) this.updateServer(this.cribScores[index]);

    if (this.sequence <= this.numberOfPages) this.sequence += 1;
    if (this.page + 1 <= this.numberOfPages) this.page += 1;
    //goto summary page
    else this.$router.push(`/outbox`);

    index = this.getIndex(this.sequence);
    this.currentCribHistory = this.getcribHistory(this.cribScores[index].kraalId);
    this.call = new Decimal(this.boundcall);
    this.score = "";
    this.edited = false;
  }

  formerPage() {
    let index = this.getIndex(this.sequence);
    if (this.edited) this.updateServer(this.cribScores[index]);

    if (this.page > 1) this.page -= 1;
    if (this.sequence > 0) this.sequence -= 1;
    index = this.getIndex(this.sequence);
    this.currentCribHistory = this.getcribHistory(this.cribScores[index].kraalId);
    this.call = new Decimal(this.boundcall);
    this.score = "";
    this.edited = false;
  }

  updateItemsPerPage(number: number) {
    this.itemsPerPage = number;
  }

  back(seq: number) {
    this.sequence = seq;
    this.formerPage();
  }

  block(seq: number) {
    //Set kraal status to blocked
    let index = this.getIndex(seq);
    this.cribScores[index].status = "blocked";
    this.edited = true;
    this.sequence = seq;
    this.nextPage();
  }

  skip(seq: number) {
    //Set kraal status to skipped
    let index = this.getIndex(seq);
    this.cribScores[index].status = "skipped";
    this.edited = true;
    this.sequence = seq;
    this.nextPage();
  }

  select(score: number, seq: number) {
    this.score = score.toString();
    let index = this.getIndex(seq);
    this.cribScores[index].score = score;
    this.cribScores[index].status = "done";
    this.edited = true;
  }
}
